import React, { PureComponent } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { CSG } from "three-csg-ts";
const Generatebase=(RF2,Diameter,scene,Thickness)=>{
    const finalBase = new THREE.Group();
    const MainBaseGeo = new THREE.CylinderGeometry(Diameter*RF2, Diameter*RF2, 2.5, 32);
    const MainBaseMat = new THREE.MeshPhongMaterial({ color: 0x808080, side: THREE.DoubleSide });
    const MainBase = new THREE.Mesh(MainBaseGeo, MainBaseMat);
    // MainBase.position.set(0,1.25,0);
    const innerMainBaseGeo = new THREE.CylinderGeometry(((Diameter*RF2)-(Thickness*RF2)), ((Diameter*RF2)-(Thickness*RF2)), 2.25);
    innerMainBaseGeo.translate(0, 0.25, 0);
    const innerMainBaseMat = new THREE.MeshPhongMaterial({
      color: 0xfffffff
    });
    const innerMainBase = new THREE.Mesh(innerMainBaseGeo, innerMainBaseMat);
    //innerMainBase.position.set(0,1.25,0);
    let subtracted = CSG.subtract(MainBase, innerMainBase);
    const higherBaseBottomGeometry = new THREE.CylinderGeometry(
        (Diameter*RF2),
          (Diameter*RF2),
        0.8,
        32
      );

      const higherBaseBottomMaterial = new THREE.MeshPhongMaterial({
        color: 0x838383,
        side: THREE.DoubleSide
      });
      const higherBaseBottomMesh = new THREE.Mesh(
        higherBaseBottomGeometry,
        higherBaseBottomMaterial
      );
      const horizontalPathGeometry = new THREE.CylinderGeometry(0.5, 0.5, (Diameter*RF2)*2);
      horizontalPathGeometry.rotateX(Math.PI / 2); // Rotate the cylinder to be horizontal
      horizontalPathGeometry.rotateZ(Math.PI / 2);
      horizontalPathGeometry.translate(0, 0.4, 0); // Rotate the cylinder to be horizontal
      const horizontalPathMaterial = new THREE.MeshPhongMaterial({
        color: 0x808080
      });
      const horizontalPathMesh = new THREE.Mesh(
        horizontalPathGeometry,
        horizontalPathMaterial
      );
      const higherBaseBottomCSG = CSG.fromMesh(higherBaseBottomMesh);
      const horizontalPathCSG = CSG.fromMesh(horizontalPathMesh);
   //   let subtractedHorizontalPathMesh = higherBaseBottomCSG.subtract(
     //   horizontalPathCSG
      //);
      let subtractedHorizontalPathMesh = higherBaseBottomMesh;
     // subtractedHorizontalPathMesh = CSG.toMesh(subtractedHorizontalPathMesh
       // ,new THREE.Matrix4(),
       // [horizontalPathMaterial,higherBaseBottomMaterial]
      //);
      subtractedHorizontalPathMesh.geometry.translate(0, 0.75, 0);

      // BaseBottomMesh.position.set(0,0.6,0);

      // grouping the base and bottom
      const BaseBottomGroup = new THREE.Group();
    //  BaseBottomGroup.add(subtractedLine);
      //     BaseBottomGroup.add(BaseBottomMesh);
      const pipeOneGeo = new THREE.CylinderGeometry(0.5, 0.5, 2.5);
      pipeOneGeo.rotateX(Math.PI / 2);
      pipeOneGeo.translate(0, 1.2, 3.5);
      const pipeOneMat = new THREE.MeshPhongMaterial({ color: 0x038000 });
      const pipeOne = new THREE.Mesh(pipeOneGeo, pipeOneMat);
      //  pipeOne.position.set(0,1.5,-3);
      const innerPipeOneGeo = new THREE.CylinderGeometry(0.3, 0.3, 2.5);
      innerPipeOneGeo.rotateX(Math.PI / 2);
      innerPipeOneGeo.translate(0, 1.2, 3.5);
      const innerPipeOneMat = new THREE.MeshPhongMaterial({ color: 0xfffffff });
      const innerPipeOne = new THREE.Mesh(innerPipeOneGeo, innerPipeOneMat);

       // finalBase.add(pipeOne);
      const pipeTwoGeo = new THREE.CylinderGeometry(0.5, 0.5, 2.5);
      pipeTwoGeo.rotateX(Math.PI / 2);
      pipeTwoGeo.translate(0, 1.2, -3.5);
      const pipeTwoMat = new THREE.MeshPhongMaterial({ color: 0x038000 });
      const pipeTwo = new THREE.Mesh(pipeTwoGeo, pipeTwoMat);
      // pipeTwo.position.set(0,1.5,3);

      // innerPipeOne.position.set(0,1.5,-3);

      const innerPipeTwoGeo = new THREE.CylinderGeometry(0.3, 0.3, 2.5);
      innerPipeTwoGeo.rotateX(Math.PI / 2);
      innerPipeTwoGeo.translate(0, 1.2, -3.5);
      const innerPipeTwoMat = new THREE.MeshPhongMaterial({ color: 0xfffffff });
      const innerPipeTwo = new THREE.Mesh(innerPipeTwoGeo, innerPipeTwoMat);

      subtracted.geometry.translate(0, 1.55, 0);

      let subtractedPipeOne = CSG.subtract(pipeOne, innerPipeOne);
      // subtractedPipeOne.position.set(0,1.2,-3);
      let subtractedPipeTwo = CSG.subtract(pipeTwo, innerPipeTwo);
      let pipeOneExtentions = new THREE.CylinderGeometry(0.5, 0.5, (Diameter*RF2));
      pipeOneExtentions.rotateX(Math.PI / 2);
      pipeOneExtentions.translate(0, 1.2, (Diameter*RF2)/2);

        const pipeOneExtentionsMat = new THREE.MeshPhongMaterial({
        color: 0xf000ff
        });
        const pipeOneExtentionsMesh = new THREE.Mesh(
        pipeOneExtentions,
        pipeOneExtentionsMat
        );
        let finalPipeOne = new THREE.Group();

       let pipeTwoExtentions = pipeOneExtentions.clone();
       pipeTwoExtentions.translate(0, -2.4, -Diameter*RF2);
         pipeTwoExtentions.rotateZ(Math.PI);

            const pipeTwoExtentionsMat = new THREE.MeshPhongMaterial({
            color: 0xf000ff
            });

            const pipeTwoExtentionsMesh = new THREE.Mesh(
            pipeTwoExtentions,
            pipeTwoExtentionsMat
            );

            subtractedHorizontalPathMesh = CSG.subtract(
            subtractedHorizontalPathMesh,
            pipeTwoExtentionsMesh
            );
      subtractedHorizontalPathMesh = CSG.subtract(
        subtractedHorizontalPathMesh,
        pipeOneExtentionsMesh
        );



      let subtractedpipeThree = subtractedPipeOne.clone();
      subtractedpipeThree.material = new THREE.MeshPhongMaterial({ color: 0x038000 });
      // Create a new geometry instance by cloning the original geometry
      subtractedpipeThree.geometry = subtractedPipeOne.geometry.clone();

      // Translate the new geometry
      subtractedpipeThree.geometry.rotateY(Math.PI / 2);

      // Add the cloned mesh to the finalBase


      // subtracted.geometry.rotateX(Math.PI/2);

     let subtracted2 = CSG.subtract(subtracted, pipeOne);
      subtracted2 = CSG.subtract(subtracted2, pipeTwo);
      subtracted2 = CSG.subtract(subtracted2, subtractedpipeThree);

      const pipeThreeExtentions = new THREE.CylinderGeometry(0.5, 0.5, 4);
      pipeThreeExtentions.rotateZ(Math.PI / 2);
      pipeThreeExtentions.translate(2, 1.2, 0);

      const pipeThreeExtentionsMat = new THREE.MeshPhongMaterial({
        color: 0xf000ff
      });
      const pipeThreeExtentionsMesh = new THREE.Mesh(
        pipeThreeExtentions,
        pipeThreeExtentionsMat
      );
      subtracted2 = CSG.subtract(subtracted2, pipeThreeExtentionsMesh);
      // finalBase.add(pipeThreeExtentionsMesh);


      subtractedHorizontalPathMesh = CSG.subtract(
     subtractedHorizontalPathMesh,
       pipeThreeExtentionsMesh
      );

      //   subtractedBaseLine.position.set(0,0.75,0);
     // finalBase.add(subtractedBaseLine);
     // finalBase.add(subtractedHorizontalPathMesh);
     // finalBase.add(subtracted2);

      finalBase.add(subtractedHorizontalPathMesh);
      finalBase.add(subtracted2);
      const Boot1 = new THREE.CylinderGeometry(0.5, 0.8, 0.5);
      Boot1.rotateX(Math.PI / 2);
      Boot1.translate(0, 1.2, 3.1);

      //grey material
      const Boot1Mat = new THREE.MeshPhongMaterial({ color: 0x808080 });

      let Boot1Mesh = new THREE.Mesh(Boot1, Boot1Mat);
      Boot1Mesh = CSG.subtract(Boot1Mesh, pipeOne);
      // Boot1Mesh.position.set(0,1.2,3.1);


      //Boot1Line.position.set(0,1.2,3.1);

    //  finalBase.add(Boot1Line);
     subtractedPipeOne.add(Boot1Mesh);
      const Boot2 = new THREE.CylinderGeometry(0.5, 0.8, 0.5);
      //grey material
      Boot2.rotateX(-Math.PI / 2);
      Boot2.translate(0, 1.2, -3.1);
      const Boot2Mat = new THREE.MeshPhongMaterial({ color: 0x808080 });

      let Boot2Mesh = new THREE.Mesh(Boot2, Boot2Mat);
     Boot2Mesh = CSG.subtract(Boot2Mesh, innerPipeTwo);
      // Boot2Mesh.position.set(0,1.2,-3.1);

      subtractedPipeTwo.add(Boot2Mesh);

      //  Boot2Line.position.set(0,1.2,-3.1);
      const Boot3Mesh = Boot1Mesh.clone();

      Boot3Mesh.geometry = Boot1Mesh.geometry.clone();
      Boot3Mesh.geometry.rotateY(Math.PI / 2);

     subtractedpipeThree.add(Boot3Mesh);

     finalBase.add(subtractedPipeOne);
     finalBase.add(subtractedPipeTwo);
     finalBase.add(subtractedpipeThree);
       return finalBase;
}
const GenerateRiser=(RF2,Diameter,RiserHeight,RiserThickness,scene)=>{
    let outerRiserGeo=  new THREE.CylinderGeometry(Diameter*RF2, Diameter*RF2, RiserHeight*RF2, 32);
    let outerRiserMat = new THREE.MeshPhongMaterial({ color: 0x808080 });
    let outerRiser = new THREE.Mesh(outerRiserGeo, outerRiserMat);
    let innerRiserGeo = new THREE.CylinderGeometry((Diameter*RF2)-(RiserThickness*RF2), (Diameter*RF2)-(RiserThickness*RF2), RiserHeight*RF2, 32);
    let innerRiserMat = new THREE.MeshPhongMaterial({ color: 0xfffffff });
    let innerRiser = new THREE.Mesh(innerRiserGeo, innerRiserMat);
    let subtractedRiser = CSG.subtract(outerRiser, innerRiser);
    subtractedRiser.geometry.translate(0, 5, 0);
    return subtractedRiser;
}
const GenerateCone = (RF2,Diameter,RiserHeight,RiserThickness,scene)=>{
    let ConLclyinder = new THREE.CylinderGeometry((Diameter*RF2), (Diameter*RF2), 0.75);
    ConLclyinder.translate(0, 7, 0);
    let ConLclyinderMat = new THREE.MeshPhongMaterial({ color: 0x808080 });
    let Con= new THREE.Mesh(ConLclyinder, ConLclyinderMat);
    let innerConLclyinder = new THREE.CylinderGeometry((Diameter*RF2)-(RiserThickness*RF2), (Diameter*RF2)-(RiserThickness*RF2), 0.75);
    innerConLclyinder.translate(0, 7, 0);

    let innerConLclyinderMat = new THREE.MeshPhongMaterial({ color: 0xfffffff });
    let innerCon= new THREE.Mesh(innerConLclyinder, innerConLclyinderMat);
    let subtractedConLclyinder = CSG.subtract(Con, innerCon);

    let realCon = new THREE.CylinderGeometry( ((Diameter*RF2)/3), ((Diameter*RF2)), 3);
    realCon.translate(0,8.5, 0);
 //   realCon.applyMatrix4(new THREE.Matrix4().makeShear(0, 0, 0, 0, 0, 0.8));
   // realCon.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.PI/4.5));

    let realConMat = new THREE.MeshPhongMaterial({ color: 0x808080 });
    let realConMesh = new THREE.Mesh(realCon, realConMat);

  let  innerRealCon = new THREE.CylinderGeometry( ((Diameter*RF2)-(RiserThickness*RF2))/3, ((Diameter*RF2)-(RiserThickness*RF2)), 3);
    innerRealCon.translate(0,8.5, 0);
    let innerRealConMat = new THREE.MeshPhongMaterial({ color: 0xfffffff });
    let innerRealConMesh = new THREE.Mesh(innerRealCon, innerRealConMat);
    let subtractedRealCon = CSG.subtract(realConMesh, innerRealConMesh);
    let finalCon = CSG.union(subtractedConLclyinder,subtractedRealCon);
    let Rem = new THREE.CylinderGeometry( ((Diameter*RF2)/3), ((Diameter*RF2)/3), 2);
    Rem.translate(0,10.25, 0);
    let RemMat = new THREE.MeshPhongMaterial({ color: 0x808080 });
    let RemMesh = new THREE.Mesh(Rem, RemMat);
    let InnerGeomtry = new THREE.CylinderGeometry( ((Diameter*RF2)-(RiserThickness*RF2))/3, ((Diameter*RF2)-(RiserThickness*RF2))/3, 2);

    InnerGeomtry.translate(0,10.25, 0);
    let innerMesh = new THREE.Mesh(InnerGeomtry, RemMat);
   RemMesh = CSG.subtract(RemMesh, innerMesh);
    finalCon = CSG.union(finalCon,RemMesh);
    return finalCon;
}
const GenerateLed = (RF2,Diameter,scene)=>{

    let LeD = new THREE.CylinderGeometry( (((Diameter*RF2)/3)), (((Diameter*RF2)/3)), 0.05);
    LeD.translate(0,11.35, 0);
    let LeDMat = new THREE.MeshPhongMaterial({ color: 0x464747,emissive:0x464747 });
    let LeDMesh = new THREE.Mesh(LeD, LeDMat);
    return LeDMesh;
}
export {Generatebase,GenerateRiser , GenerateCone, GenerateLed};